import Vue from 'vue'
import Vuex from 'vuex'
//登录
import { login } from '@/api/index'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import { encrypt, decrypt } from '@/utils/jsencrypt'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: Cookies.get('token') || '',
    username: Cookies.get('username') || '',
    password: Cookies.get('password') || ''
  },
  getters: {},
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_PASSWORD: (state, password) => {
      state.password = password
    }
  },
  actions: {
    // 调用api登录方法
    Login({ commit }, userInfo) {
      const username = userInfo.username
      const username2 = userInfo.username2
      const password2 = userInfo.password2
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid)
          .then((res) => {
            if (res.data.code !== 200) {
              // 在 then的内部不能使用Vue的实例化的this, 因为在内部 this 没有被绑定
              reject(res.data.msg)
              return
            }
            //将token设置在cookie里
            // setToken(res.data.token)

            Cookies.set('token', res.data.token, { expires: 30 })
            Cookies.set('username', username2, { expires: 30 })
            Cookies.set('password', encrypt(password2), {
              expires: 30
            })

            //提交修改
            commit('SET_TOKEN', res.data.token)
            commit('SET_USERNAME', username2)
            commit('SET_PASSWORD', password2)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 退出系统（暂无登出方法）
    LogOut() {}
  },
  modules: {}
})
